var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1522 16.62C24.9491 12.823 24.9491 6.64475 21.1522 2.84775C17.3552 -0.949249 11.1771 -0.949249 7.38017 2.84775C4.15893 6.06898 3.67108 10.8598 5.91529 14.6009C5.91529 14.6009 6.07649 14.8713 5.85877 15.0889C4.61671 16.3309 0.890302 20.0574 0.890302 20.0574C-0.0986291 21.0462 -0.334052 22.429 0.542928 23.3061L0.693923 23.457C1.5709 24.3341 2.95375 24.0987 3.9426 23.1098C3.9426 23.1098 7.66113 19.3912 8.90064 18.1518C9.12879 17.9236 9.39916 18.0848 9.39916 18.0848C13.1402 20.329 17.931 19.8412 21.1522 16.62ZM9.17804 14.822C6.37245 12.0164 6.37253 7.45145 9.17812 4.64585C11.9837 1.84034 16.5487 1.84026 19.3542 4.64585C22.1598 7.45137 22.1598 12.0164 19.3542 14.822C16.5486 17.6274 11.9837 17.6274 9.17804 14.822Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79986 9.15701C9.66927 9.15701 9.53653 9.13134 9.40857 9.07729C8.89744 8.86097 8.65831 8.27121 8.87463 7.76001C10.2343 4.54689 13.9544 3.03902 17.1675 4.39868C17.6786 4.61501 17.9177 5.20476 17.7014 5.71597C17.485 6.22717 16.8954 6.46615 16.384 6.2499C14.1919 5.32228 11.6535 6.3511 10.7259 8.54328C10.5636 8.92669 10.1915 9.15701 9.79986 9.15701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.552e4d825f0e8ea6ab7c80c636e4176a.svg";
export { ForwardRef as ReactComponent };